<template>
  <a-steps progress-dot :current="movementsQuantity" direction="vertical">
    <a-step
      v-if="movementsQuantity > 0"
      v-for="movement in movements"
      :key="movement.id"
      :title="movement.time.format('h:mm a, Do MMMM YYYY')"
      :description="movement.address"
    />
  </a-steps>
</template>

<script>
export default {
  name: "FreightMateMovements",
  props: {
    movements: {
      type: Array,
      required: true,
    }
  },
  computed: {
    movementsQuantity: function () {
      return this.movements.length;
    }
  }
}
</script>

<style scoped>

</style>
